var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c--footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"c--footer__copyright"},[_vm._v("© "+_vm._s(_vm.year)+" IMPACT")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }